export default {
  dashboard: {
    catalog_widget: {
      header: {
        title: 'Your catalog',
      },
      body: {
        title_published_items: 'Active items',
        title_unpublished_items: 'Inactive items',
        title_actived_users: 'Active users',
      },
    },
    match_widget: {
      header: {
        title: 'Catalog activity',
      },
      body: {
        appearances_in_search: 'Appearances in Search',
        items_with_match: 'Items with MATCH',
        items_displayed: 'Items displayed',
        buyers_who_viewed_your_items: 'Buyers who viewed your items',
      },
    },
    titles: {
      news: 'News',
      tenders: 'Materials quoted in UNILINK',
      orders: 'Quoted amounts in UNILINK​',
    },
    consult: {
      tooltip: 'You can consult for all UNILINK data or your associated company data',
      transactions: 'You can check for materials or categories quoted by UNILINK, either for the entire community or just for your company​',
      volume: 'You can consult for the values quoted in UNILINK, either for the entire community or only for your company',
    },
    noData: 'No data available to show',
    details: 'View details',
    search: 'Search',
    dates: {
      from: 'Start date',
      to: 'End date',
      filterInfo: 'For your query you can filter by date range and by category',
      begining: 'From',
      end: 'To',
    },
    myCompany: 'My Company',
    activity: 'Activity in cotizations',
    itemsName: 'Item name',
    companyName: 'Company name',
    allCategories: 'All categories',
    companyBuyer: 'Company buyer',
    table: {
      CompradorNombre: 'Buyer name',
      CategoriaId: 'Category ID',
      CategoriaNombre: 'Category name',
      ItemDescripcion: 'Item description',
      ItemCantidad: 'Item quantity',
      ItemPosicion: 'Item position',
      RfqFechaCreacion: 'Rfq creation date',
      RfqFechaCierre: 'Rfq closing date',
      RfqPrecio: 'Rfq price',
      RfqMoneda: 'Rfq currency',
    },
    excel: {
      generate: 'Generate Excel',
      noData: 'No data available to show',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/dashboard.js